export const initialState = () => ({
  loading: true,
  result: [],
  error: false
})
